/**
 * 客户端push模块 路由
 */
"use strict";
angular.module("planCommandMonitorClientPushManagementRouterModule", [
        'clientPushManagementModule',
        'clientPushManagementAddAndEditModule'
    ])
    .config(["$stateProvider", function($stateProvider) {
        $stateProvider
            .state("front.planningresource.commandMonitor.clientPushManagement", {
                url: '/clientPushManagement',
                views: {
                    'main@front.planningresource.commandMonitor': {
                        templateUrl: './planningResource/commandMonitor/clientPushManagement/clientPushManagement_tpl.html',
                        controller: "clientPushManagementCtrl",
                    }
                }
            })
    }]);